module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content Section")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Konten")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('type') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$route.query.id ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SINGLE_BANNER"
    }
  }, [_vm._v("Single Banner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MULTIPLE_BANNER"
    }
  }, [_vm._v("Multiple Banner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EXERCISE"
    }
  }, [_vm._v("Latihan Soal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ONGOING_TRYOUT"
    }
  }, [_vm._v("Tryout Berlangsung")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TRYOUT_RESULT"
    }
  }, [_vm._v("Hasil Tryout")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIDEO"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ARTICLE"
    }
  }, [_vm._v("Artikel")])]), _vm._v(" "), (_vm.form.type === 'VIDEO') ? _c('div', {
    staticClass: "alert alert-warning mt-2",
    attrs: {
      "role": "alert"
    }
  }, [_c('b', [_vm._v("Perhatian!")]), _vm._v(" semua konten dengan type 'Video' akan diisi video/detail yang sama secara otomatis oleh sistem")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('name') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Content")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d2b372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/content/Form.vue
// module id = 1320
// module chunks = 0